import React from 'react';
import PropTypes from 'prop-types';
import NoticeTooltipOnHover from '../../_utils/notice-tooltip';

export const PREVIEW_UNAVAILABLE_MESSAGE =
  'Preview unavailable. This photo uploaded correctly and will be printed; only its preview could not be loaded.';

// Shown when every thumbnail URL for a photo failed to load. The photo itself is fine and
// remains orderable, so this is a notice rather than an error - it exists to stop the tile
// looking like a broken or still-loading photo.
const PhotoPreviewUnavailable = ({ tooltipPosition }) => (
  <NoticeTooltipOnHover
    tooltipCSSClasses="photo-preview-unavailable-tooltip"
    tooltipPosition={tooltipPosition}
    content={PREVIEW_UNAVAILABLE_MESSAGE}
    show={false}>
    <div
      data-test-id="photo-preview-unavailable"
      className="photo-preview-unavailable d-flex align-items-center justify-content-center text-center"
      aria-label={PREVIEW_UNAVAILABLE_MESSAGE}
      role="status"
      tabIndex="0">
      <span aria-hidden="true">No preview</span>
    </div>
  </NoticeTooltipOnHover>
);

PhotoPreviewUnavailable.propTypes = {
  tooltipPosition: PropTypes.string,
};

PhotoPreviewUnavailable.defaultProps = {
  tooltipPosition: undefined,
};

export default PhotoPreviewUnavailable;
